import styled from "styled-components";
import { theme } from "../theme";

export const StyledSelectableUpperUnit = styled.label`
	text-transform: initial;
	display: block;
	position: relative;
	cursor: pointer;
	padding: 1.5rem 1rem;
	background-color: ${({ checked }) => (checked ? theme.color.blue1 : "transparent")};
	border-bottom: 1px solid ${theme.color.blue1};
	margin: 0;

	.checkmark {
		position: absolute;
		top: 50%;
		left: 1rem;
		width: 1.8rem;
		height: 1.8rem;
		border-radius: 50%;
		border: 0.1rem solid ${theme.color.gray0};
		background-color: transparent;
		transform: translateY(-50%);

		&:after {
			content: "";
			position: absolute;
			display: none;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: ${theme.color.green};
		}
	}

	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;

		&:checked {
			& ~ .checkmark {
				background-color: ${theme.color.white};

				&:after {
					display: block;
				}
			}
		}
	}
`;

export const StyledSelectableUpperUnitWrapper = styled.div`
	display: grid;
	row-gap: 1rem;
	padding: 0 0 0 3rem;
	color: ${theme.color.black};
	font-size: 1.2rem;
	font-weight: 500;
	font-family: ${theme.font.secondary};
`;
